var OCS = OCS || {};
OCS.Geometry = OCS.Geometry || {};
OCS.Geometry.Functions = OCS.Geometry.Functions || {};
OCS.Geometry.Functions.getCrsProjectionName = function(crs_input) {
    var output = {properties: {name: ""}, type: "name"};
    if(crs_input.type === "link") {
        switch(crs_input.properties.href) {
            case "http://spatialreference.org/ref/sr-org/7483/proj4/":
                output.properties.name = "urn:ogc:def:crs:EPSG::3857";
                break;
            case "http://spatialreference.org/ref/epsg/4326/proj4/":
                output.properties.name = "urn:ogc:def:crs:EPSG::4326";
                break;
        }
    }
    if(crs_input.type === "name") {
        return crs_input;
    }
    return output;
};
OCS.Geometry.Functions.getShortCrsProjectionName = function(crs_input) {
    var string = String(crs_input);
    if(string.length > 10) {
        return string.substring(string.length-10).replace('::',':');
    } else {
        return string.replace('::',':');
    }

};